




























































































import 'reflect-metadata'
import { Mixins, Component } from 'vue-property-decorator'
import TooltipMeta from '@/components/Home/TopInfo/TooltipMeta.vue'
import { bigToDenomBig } from '@/helper'
import { AuthorityGettersMixin } from '@/store/modules/authority/authority.mixins'

@Component({
    components: {
        TooltipMeta,
    },
})
export default class ValidatorStats extends Mixins(AuthorityGettersMixin) {
    get subnetsLoaded(): boolean {
        return this.$store.state.Authority.subnetsLoaded
    }

    get totalValidatorsCount() {
        return this.getTotalValidators()
    }

    get totalPendingValidatorsCount() {
        return this.getTotalPendingValidators()
    }

    get totalStake(): string {
        let totalStake = this.getTotalStake()
        totalStake = bigToDenomBig(totalStake, 9)
        return totalStake.toLocaleString(0)
    }

    get percentStaked() {
        return this.getStakingRatio()
    }

    get annualStakingRewardPercentage(): string {
        const APR = this.$store.state.Authority.annualStakingRewardPercentage
        return `${APR.toFixed(1)}%`
    }
}
